export default from './MortgageSurvey';



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurvey/index.js